import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height: 75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 45px; 
      height: 55px;
    }`
  }
`

const ChartImageIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG version="1.0" xmlns="http://www.w3.org/2000/svg"
      width="60px" height="75px" viewBox="0 0 1200.000000 1063.000000"
      preserveAspectRatio="xMidYMid meet" isFromWidgetChoice={isFromWidgetChoice}>
      <g transform="translate(0.000000,1063.000000) scale(0.100000,-0.100000)"
        fill="currentColor" stroke="none">
      <path d="M1335 9964 c-172 -36 -264 -72 -379 -148 -199 -132 -342 -345 -390
        -578 -14 -70 -16 -426 -16 -3662 0 -3881 -3 -3644 53 -3798 45 -124 105 -216
        212 -324 142 -144 282 -221 470 -258 73 -15 502 -16 4795 -14 4514 3 4718 4
        4775 21 103 32 256 111 337 175 165 131 275 308 325 518 17 76 18 212 18 3684
        0 3387 -1 3609 -17 3672 -46 179 -127 325 -246 446 -112 113 -245 192 -413
        244 l-74 23 -4715 1 c-2593 1 -4724 0 -4735 -2z m9350 -753 c50 -22 91 -69
        105 -119 14 -52 14 -6982 -1 -7035 -13 -47 -63 -106 -106 -123 -27 -12 -793
        -14 -4643 -14 -4505 0 -4612 0 -4648 19 -42 22 -63 43 -86 88 -15 29 -16 326
        -16 3551 l0 3518 29 45 c18 30 44 53 72 67 l44 22 4605 0 c4446 0 4606 -1
        4645 -19z"/>
      <path d="M2980 8500 c-200 -24 -398 -108 -559 -236 -432 -346 -538 -975 -243
        -1443 262 -415 747 -605 1227 -481 104 27 281 114 370 181 459 349 576 977
        273 1470 -63 102 -203 249 -303 318 -222 154 -497 222 -765 191z"/>
      <path d="M6223 6128 l-1463 -1463 -458 458 -457 457 -918 -918 -917 -917 0
        -553 0 -552 4030 0 4030 0 0 1288 0 1287 -1188 1188 c-653 653 -1189 1187
        -1192 1187 -3 0 -663 -658 -1467 -1462z"/>
      </g>
    </SVG>
  </IconContainer>
)

export default ChartImageIcon